/**
 * Truncates blog list card descriptions on mobile devices
 * Uses data attributes set in Liquid template to switch between mobile/desktop text
 */
(function() {
  const MOBILE_BREAKPOINT = 768;
  
  function updateDescriptions() {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    const descriptions = document.querySelectorAll('.card--list-layout .card__description[data-description-mobile]');
    
    descriptions.forEach(desc => {
      const mobileText = desc.dataset.descriptionMobile;
      const desktopText = desc.dataset.descriptionDesktop;
      
      if (isMobile && mobileText) {
        desc.textContent = mobileText;
      } else if (!isMobile && desktopText) {
        desc.textContent = desktopText;
      }
    });
  }
  
  // Update on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDescriptions);
  } else {
    updateDescriptions();
  }
  
  // Update on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateDescriptions, 150);
  });
  
  // Update when new content is loaded (for infinite scroll)
  document.addEventListener('shopify:section:load', updateDescriptions);
})();
